import { render, staticRenderFns } from "./GymForm.vue?vue&type=template&id=35e8d930&"
import script from "./GymForm.vue?vue&type=script&lang=js&"
export * from "./GymForm.vue?vue&type=script&lang=js&"
import style0 from "./GymForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports